import { Selector } from '@ngxs/store';
import { GenericState } from '@store/states/generic.state';
import { GenericStateModel } from '@store/models/generic.model';

export class GenericSelectors {
  @Selector([GenericState])
  static AppVariant(state: GenericStateModel) {
    return state.variant;
  }
}
